/**
 * Generated runtime TestId mirror for frontend/src/components/shared/PeerRecommendationList.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const PeerRecommendationListTestIds = {
  peerRecommendationList: "peer-recommendation-list",
  peerRecommendationListItems: "peer-recommendation-list-items",
  peerRecommendationListTitle: "peer-recommendation-list-title",
  btnAddPeerProfile: (peer_accessProfile_id: string) => `btn-add-peer-profile-${peer_accessProfile_id}`,
  btnAddPeerProfilePrefix: () => "btn-add-peer-profile-" as TestIdPrefix,
  peerRecommendationRow: (peer_accessProfile_id: string) => `peer-recommendation-row-${peer_accessProfile_id}`,
  peerRecommendationRowPrefix: () => "peer-recommendation-row-" as TestIdPrefix
} as const;
